import { render, staticRenderFns } from "./CustomerAccountEnquiry.vue?vue&type=template&id=e2a71a6c&scoped=true&"
import script from "./CustomerAccountEnquiry.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountEnquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a71a6c",
  null
  
)

export default component.exports